<template>
  <div class="request-subjects text-dark">
    <div class="request-subjects__header">
      <h1>Ønsker til fagfordelingen</h1>
    </div>
    <Loader v-if="isLoading || isLoadingSubjectsRequests"></Loader>
    <div class="request-subjects-grid" v-else>
      <RequestSubjectsUser
        :user="user"
        :assignedTeaching="assignedSubjectsTeaching"
        :assignedOther="assignedSubjectsOther"
        :showAssignedSubjects="canShowAssignedSubjects"
        :userSubjectsTeaching="userRequestedTeachingSubjects"
        :userSubjectsOther="userRequestedOtherSubjects"
        :allCalendarsInHash="allCalendarsInHash"
        :loadingSubjects="loadingSubjects"
        :isPoolsDeactivated="isPoolsDeactivated"
        :poolTeachingHours="poolTeachingHours"
        :poolOtherHours="poolOtherHours"
        :hasOtherSubjects="hasOtherSubjects"
        :showLessonsPerWeek="isLessonsPerWeekActive"
        :subjectDefaultDuration="subjectDefaultDuration"
        @removeSubject="onSetSubjectRequest($event)">
      </RequestSubjectsUser>
      <div class="doTable">
        <div class="subject-dist__header">
          <div class="subject-dist__header__left">
            <!--
            <Tabs :tabs="['Fag', 'Opgaver']" :selected="selectedTab" @select="onSelectTab"></Tabs>
            <div class="do-search" v-if="selectedTab === 'Fag'">
              <input type="search" class="do-input" placeholder="Søg på fag" @input="debounceSearch">
            </div>
            -->
            <DoFiltersFilter
              v-if="selectedTab === 'Fag'"
              :title="'Klasser'"
              :tags="klassTags"
              :selectedTags="selectedKlassFilters"
              @select="toggleKlassTag"
              @clear="selectedKlassFilters = []"
            >
            </DoFiltersFilter>
            <DoFiltersFilter
              v-if="selectedTab === 'Fag'"
              :title="'Status på fag'"
              :tags="statusFilters"
              :selectedTags="selectedStatusFilters"
              @select="toggleSelectedStatusFilters"
              @clear="selectedStatusFilters = []"
            >
            </DoFiltersFilter>
          </div>
          <div v-if="isSchoolDanish" class="label-with-toggle" @click="showLessonsPerWeek = !showLessonsPerWeek">
            <label class="d-label">Se undervisning i lektioner</label>
            <AppToggle :allowChanges="false" :propOn="showLessonsPerWeek" @changed="showLessonsPerWeek = $event"></AppToggle>
        </div>
        </div>
        <table class="do-table do-table__tasks" v-if="selectedTab === 'Opgaver'">
          <thead>
          <tr>
            <th>Opgave</th>
            <th class="td-number">Timer</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="task in tasks" :key="task.id">
            <td>
              <button class="do-bttn do-bttn--request-subject marg-1-right" @click="onSetSubjectRequest (task.id)">
                Ønsk
              </button>
              {{ task.name }}
            </td>
            <td class="td-number">{{ task.hours }}</td>
          </tr>
          </tbody>
        </table>
        <ul class="doTable__items" v-else>
          <li class="doTable__klass"
              v-for="(klassCal, idx) in filteredKlassCals"
              :key="klassCal.id">
            <div class="doTable__klass__header">
              <div>{{ klassCal.name }}</div>
            </div>
            <ul class="subjects">
              <li class="subjects_subject"
                  v-for="subject in klassCal.vSubjects"
                  :key="subject.id"
                  :class="[{'subject--has-user': subject.vRequestedBy.length > 0}]"
                  :style="{'background': subject.color}"
                  :content="!subject.vHasTeachers ? 'Ønsket af ' + subject.vRequestedBy : subject.vUserNames + ' er valgt'"
                  v-tippy="{
            arrow: true,
            onShow: () => subject.vRequestedBy.length > 0 || subject.vHasTeachers
          }">

                {{ subject.name }} ({{ isLessonsPerWeekActive && subject.master_type !== 'other' ? subject.vLessonsPerWeek : subject.vHours }})
                <button class="do-bttn do-bttn--request-subject"
                        v-if="!subject.vHasTeachers"
                        :class="{'do-bttn--remove': subject.vIsRequestedByUser}"
                        @click="onSetSubjectRequest(subject.id)">
                  <div class="do-spinner do-spinner__small" v-if="subject.vIsLoading"></div>
                  <template v-else>
                    {{ subject.vIsRequestedByUser ? 'Fjern ønske' : 'Ønsk' }}
                  </template>
                </button>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import Loader from '../common/Loader.vue'
import DoFiltersFilter from '../DoFilters/DoFiltersFilter.vue'
import RequestSubjectsUser from './RequestSubjectsUser.vue'
import AppToggle from '../common/AppToggle.vue'
import docendo from '../../docendo'
import eventbus from '../../eventbus'
import Tabs from '../common/Tabs.vue'

export default {
  components: {Tabs, RequestSubjectsUser, DoFiltersFilter, Loader, AppToggle},
  data () {
    return {
      selectedTab: 'Fag',
      selectedKlassFilters: [],
      selectedStatusFilters: ['Fag uden tildelt underviser'],
      loadingSubjects: {},
      subjectSearchQuery: '',
      debounceTimer: null,
      schoolYearId: null,
      userAssignedTeachingTasks: [],
      userAssignedOtherTasks: [],
      userPoolData: null,
      showLessonsPerWeek: false
    }
  },
  computed: {
    schoolId () {
      return this.$store.getters.schoolId
    },
    school () {
      return this.$store.state.activeSchool
    },
    isSchoolDanish () {
      return this.school && this.school.country ? this.school.country.toLowerCase() === 'dk' : false
    },
    subjectDefaultDuration () {
      return this.school && this.school.subject_default_duration ? this.school.subject_default_duration : 45
    },
    isLessonsPerWeekActive () {
      return this.isSchoolDanish && this.showLessonsPerWeek
    },
    user () {
      return this.$store.state.user
    },
    userCalendarId () {
      return this.user && this.user.user_calendar_id ? this.user.user_calendar_id : null
    },
    schoolYears () {
      return this.$store.state.schoolYears
    },
    requestedSchoolYear () {
      if (!this.schoolYearId) {
        return null
      }
      return this.schoolYears.find(year => year.id === this.schoolYearId * 1) || null
    },
    canShowAssignedSubjects () {
      return !!(this.user && this.user.id &&
        this.requestedSchoolYear &&
        this.requestedSchoolYear.employee_time_start &&
        this.requestedSchoolYear.employee_time_end)
    },
    isLoading () {
      return this.$store.state.subjects.isLoading
    },
    subjects () {
      return this.$store.state.subjects.subjects
    },
    hasOtherSubjects () {
      return this.subjects.some(subject => subject.master_type === 'other')
    },
    requestedSubjects () {
      return this.$store.getters.subjectsRequestsInHash
    },
    isShowSubjectsWithoutTeachers () {
      return this.selectedStatusFilters.includes('Fag uden tildelt underviser')
    },
    allCalendarsInHash () {
      return this.$store.getters.allCalendarsInHash
    },
    subjectsInKlassHash () {
      return this.$store.getters.subjectsInKlassHash
    },
    subjectsInHash () {
      return this.$store.getters.subjectsInHash
    },
    subjectsInUserHash () {
      return this.$store.getters.subjectsInUserHash
    },
    klassCalendars () {
      const cals = []
      const seenIds = new Set()
      this.subjects.forEach(subject => {
        subject.cals.forEach(cal => {
          if (cal.calendar_type === 'klass' && !seenIds.has(cal.id)) {
            seenIds.add(cal.id)
            cals.push(cal)
          }
        })
      })
      return cals.sort((a, b) => a.name.localeCompare(b.name))
    },
    klassTags () {
      return this.klassCalendars.map(klassCalendar => klassCalendar.name)
    },
    calsWithProps () {
      const klasses = this.klassCalendars

      return klasses.map(klass => ({
        ...klass,
        vSubjects: (this.subjectsInKlassHash[klass.id] || [])
          .filter(subjectId => {
            const subject = this.subjectsInHash[subjectId] || {}
            return subject.subject_type !== 'frame' && subject.subject_type !== 'activity'
          })
          .map(subjectId => {
            const subject = this.subjectsInHash[subjectId] || {}

            const vHours = this.getSubjectHoursForKlass(subject, klass.id)
            return {
              ...subject,
              vHours: vHours,
              vLessonsPerWeek: this.calcLessonsPerWeek(this.getSubjectHoursForLessons(subject)),
              vRequestedBy: this.getSubjectedRequestedBy(subjectId),
              vTotalRequestCount: (this.requestedSubjects[subjectId] || []).length,
              vHasTeachers: this.subjectHasTeachers(subjectId),
              vUserNames: this.getUserNames(subjectId),
              vIsRequestedByUser: this.getIsSubjectRequestedByUser(subjectId),
              vIsLoading: this.getIsSubjectLoading(subjectId)
            }
          })
      }))
    },
    filteredKlassCals () {
      let klasses = this.calsWithProps

      // Filtrer klasser baseret på valgte klasses
      if (this.selectedKlassFilters.length > 0) {
        klasses = klasses.filter(klass => this.selectedKlassFilters.includes(klass.name))
      }

      // Hvis ingen statusfiltre er valgt, vis alle subjects
      const hasStatusFilters = this.selectedStatusFilters.length > 0

      return klasses.map(klass => ({
        ...klass,
        vSubjects: klass.vSubjects.filter(subject => {
          // Filtrering baseret på statusfiltre
          const matchesStatusFilter = !hasStatusFilters || (
            this.selectedStatusFilters.includes('Fag uden tildelt underviser') && !subject.vHasTeachers ||
            this.selectedStatusFilters.includes('Fag med tildelt underviser') && subject.vHasTeachers ||
            this.selectedStatusFilters.includes('Fag jeg har ønsket') && subject.vIsRequestedByUser ||
            this.selectedStatusFilters.includes('Fag ønsket af flere') && subject.vTotalRequestCount >= 2 ||
            this.selectedStatusFilters.includes('Fag ingen har ønsket') && subject.vTotalRequestCount === 0
          )

          // Filtrering baseret på søgefeltet
          const matchesSearch = !this.subjectSearchQuery ||
            subject.name.toLowerCase().includes(this.subjectSearchQuery.toLowerCase())

          // Begge betingelser skal være opfyldt
          return matchesStatusFilter && matchesSearch
        })
      }))
    },
    subjectsRequests () {
      return this.$store.state.subjects.subjectsRequests
    },
    isLoadingSubjectsRequests () {
      return this.$store.state.subjects.isLoadingSubjectsRequests
    },
    userRequestedSubjects () {
      if (!this.user) {
        return []
      }
      return this.subjects.filter(subject => this.getIsSubjectRequestedByUser(subject.id))
    },
    userRequestedSubjectsWithProps () {
      return this.userRequestedSubjects
        .map(subject => {
          const vHours = this.getSubjectHoursForKlass(subject, subject.calendar_id)
          return {
            ...subject,
            vHours: vHours,
            vLessonsPerWeek: this.calcLessonsPerWeek(this.getSubjectHoursForLessons(subject)),
            vKlass: this.getKlassesOnSubjects(subject),
            vRequestedBy: this.getSubjectedRequestedBy(subject.id)
          }
        })
        .sort((a, b) => a.name.localeCompare(b.name))
    },
    userRequestedTeachingSubjects () {
      return this.userRequestedSubjectsWithProps.filter(subject => subject.master_type !== 'other')
    },
    userRequestedOtherSubjects () {
      return this.userRequestedSubjectsWithProps.filter(subject => subject.master_type === 'other')
    },
    assignedSubjectsTeaching () {
      if (!this.canShowAssignedSubjects) {
        return []
      }
      return this.userAssignedTeachingTasks.slice().sort((a, b) => a.name.localeCompare(b.name))
    },
    assignedSubjectsOther () {
      if (!this.canShowAssignedSubjects) {
        return []
      }
      return this.userAssignedOtherTasks.slice().sort((a, b) => a.name.localeCompare(b.name))
    },
    schoolSettings () {
      return this.$store.state.schoolSettings
    },
    isPoolsDeactivated () {
      return this.schoolSettings && this.schoolSettings['deactivatePools'] ? this.schoolSettings['deactivatePools'] : false
    },
    poolTeachingHours () {
      if (!this.userPoolData) {
        return 0
      }
      const val = parseFloat(this.userPoolData.assigned_teaching_hours)
      return isNaN(val) ? 0 : val
    },
    poolOtherHours () {
      if (!this.userPoolData) {
        return 0
      }
      const val = parseFloat(this.userPoolData.assigned_additional_task_hours)
      return isNaN(val) ? 0 : val
    },
    isPermissionsActivatedForSchool () {
      return this.$store.getters.isPermissionsActivatedForSchool
    },
    userPermissions () {
      return this.$store.getters.userPermissions
    },
    canSeeOtherSubjectRequests () {
      if (!this.user) return false
      if (!this.isPermissionsActivatedForSchool) return true
      return (this.userPermissions && this.userPermissions.indexOf('can_see_other_subject_requests') > -1) || this.user.admin
    },
    statusFilters () {
      const filters = [
        'Fag uden tildelt underviser',
        'Fag med tildelt underviser',
        'Fag jeg har ønsket'
      ]
      if (this.canSeeOtherSubjectRequests) {
        filters.push('Fag ønsket af flere', 'Fag ingen har ønsket')
      }
      return filters
    }
  },
  methods: {
    calcLessonsPerWeek (hours) {
      return this.$helpers.calcLessonsPerWeek(hours, this.subjectDefaultDuration)
    },
    getSubjectHoursForKlass (subject, klassCalId) {
      if (subject.subject_calendars) {
        var entry = subject.subject_calendars.find(function (sc) { return sc.calendar_id === klassCalId })
        if (entry && entry.hours != null) {
          return entry.hours
        }
      }
      return subject.hours
    },
    getSubjectHoursForLessons (subject) {
      if (subject.subject_calendars && this.userCalendarId) {
        var entry = subject.subject_calendars.find(function (sc) { return sc.calendar_id === this.userCalendarId }.bind(this))
        if (entry && entry.hours != null) {
          return entry.hours
        }
      }
      return subject.hours
    },
    getKlassesOnSubjects (subject) {
      const cal = this.allCalendarsInHash[subject.calendar_id]
      return cal ? cal.name : ''
    },
    readUserTeachingTasks () {
      if (!this.canShowAssignedSubjects) {
        this.userAssignedTeachingTasks = []
        this.userAssignedOtherTasks = []
        return
      }
      docendo.userTasks(
        this.user.id,
        this.requestedSchoolYear.employee_time_start,
        this.requestedSchoolYear.employee_time_end,
        success => {
          const rows = Array.isArray(success) ? success : (success && Array.isArray(success.data) ? success.data : [])
          const mapped = rows.filter(row => row).map(row => {
            const hoursUser = parseFloat(row.hours_user)
            const hoursSubject = parseFloat(row.hours_subject)
            const hours = parseFloat(row.hours)
            let vHours = 0
            if (!isNaN(hoursUser)) {
              vHours = hoursUser
            } else if (!isNaN(hoursSubject)) {
              vHours = hoursSubject
            } else if (!isNaN(hours)) {
              vHours = hours
            }
            const isOtherKind = row.master_type === 'other' ||
              (row.subject_type === 'additional_tasks' && row.master_type !== 'teaching')
            const vType = row.subject_type === 'subject'
              ? 'Fag'
              : (isOtherKind ? 'Øvrig opgave' : 'Undervisningsopgave')
            return {
              ...row,
              rowId: 'user_task_' + row.id,
              vKlass: row.calendar || '',
              vHours: vHours,
              vType: vType
            }
          })
          const isTeachingAssigned = row => {
            if (row.master_type === 'other') {
              return false
            }
            return row.subject_type === 'subject' ||
              row.subject_type === 'person_resource' ||
              row.subject_type === 'person_resource_visible' ||
              row.master_type === 'teaching'
          }
          const isOtherAssigned = row => {
            if (row.master_type === 'other') {
              return true
            }
            return row.subject_type === 'additional_tasks' && row.master_type !== 'teaching'
          }
          this.userAssignedTeachingTasks = mapped.filter(isTeachingAssigned)
          this.userAssignedOtherTasks = mapped.filter(isOtherAssigned)
        },
        failure => {
          this.userAssignedTeachingTasks = []
          this.userAssignedOtherTasks = []
          console.log('failed read user tasks', failure)
        }
      )
    },
    onSelectTab (tab) {
      this.selectedTab = tab
    },
    debounceSearch (event) {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        this.subjectSearchQuery = event.target.value
      }, 400)
    },
    getSubjectedRequestedBy (subjectId) {
      const currentCalendarIds = this.requestedSubjects[subjectId] || []
      return currentCalendarIds.filter(calId => calId !== this.userCalendarId && this.allCalendarsInHash[calId]).map(calId => this.allCalendarsInHash[calId] ? this.allCalendarsInHash[calId]['name'] : [])
    },
    getIsSubjectRequestedByUser (subjectId) {
      const userCalendarId = this.userCalendarId
      const currentUserIds = this.requestedSubjects[subjectId]
      return currentUserIds && currentUserIds.includes(userCalendarId)
    },
    onSetSubjectRequest (subjectId) {
      // Sæt loading til true
      this.$set(this.loadingSubjects, subjectId, true)
      // Tjek om brugeren allerede er på == fjern
      if (this.getIsSubjectRequestedByUser(subjectId)) {
        const idx = this.subjectsRequests.findIndex(subjectsReq => subjectsReq.subject_id === subjectId && subjectsReq.calendar_id === this.userCalendarId)
        if (idx > -1) {
          const reqId = this.subjectsRequests[idx]['id']
          // Fjern den
          docendo.deleteSubjectRequest(this.schoolId, this.schoolYearId, reqId, success => {
            this.$store.commit('removeSubjectRequest', success)
            this.$delete(this.loadingSubjects, subjectId)
          }, failure => {
            this.$delete(this.loadingSubjects, subjectId)
          })
        }
      } else {
        // Tilføj hvis den ikke findes
        docendo.createSubjectRequest(this.schoolId, this.schoolYearId, subjectId, success => {
          console.log(success)
          if (success && success.status && success.status === 'error') {
            eventbus.toast = {text: 'Fagønsker er ikke åbne for dette skoleår', success: false}
            this.$delete(this.loadingSubjects, subjectId)
            return
          }
          this.$store.commit('addSubjectRequest', success)
          this.$delete(this.loadingSubjects, subjectId)
        }, failure => {
          eventbus.toast = {text: 'Fagønsker er ikke åbne for dette skoleår', success: false}
          this.$delete(this.loadingSubjects, subjectId)
        })
      }
    },
    getIsSubjectLoading (subjectId) {
      return this.loadingSubjects[subjectId]
    },
    toggleSelectedStatusFilters (filter) {
      const idx = this.selectedStatusFilters.indexOf(filter)
      if (idx < 0) {
        this.selectedStatusFilters.push(filter)
      } else {
        this.selectedStatusFilters.splice(idx, 1)
      }
    },
    toggleKlassTag (filter) {
      const idx = this.selectedKlassFilters.indexOf(filter)
      if (idx < 0) {
        this.selectedKlassFilters.push(filter)
      } else {
        this.selectedKlassFilters.splice(idx, 1)
      }
    },
    setEditSubject (editSubject) {
      console.log('setEditSubject', editSubject)
    },
    getUserNames (subjectId) {
      let calIds = this.subjectsInHash[subjectId] ? this.subjectsInHash[subjectId].calendar_ids : []
      if (!calIds || calIds.length < 1 || !calIds[0]) {
        return ''
      }
      return calIds.filter(calId => this.allCalendarsInHash[calId] && this.allCalendarsInHash[calId].type === 'user').map(userCalId => this.allCalendarsInHash[userCalId].name ? this.allCalendarsInHash[userCalId].name : '')
    },
    isShowWithoutTeacher (subjectid) {
      if (!this.isShowSubjectsWithoutTeachers) {
        return true
      } else {
        return !this.subjectHasTeachers(subjectid)
      }
    },
    subjectHasTeachers (subjectId) {
      let calIds = this.subjectsInHash[subjectId] ? this.subjectsInHash[subjectId].calendar_ids : []
      let hasTeachers = false
      calIds.forEach(calId => {
        if (this.allCalendarsInHash[calId] && this.allCalendarsInHash[calId].type === 'user') {
          hasTeachers = true
        }
      })
      return hasTeachers
    },
    readUserPoolData () {
      if (!this.schoolId || !this.schoolYearId || !this.user || !this.user.id) {
        this.userPoolData = null
        return
      }
      docendo.schoolUserYearsList(this.schoolId, this.schoolYearId, this.user.id, data => {
        const rows = Array.isArray(data) ? data : []
        const match = rows.find(row => row && row.user_id === this.user.id)
        this.userPoolData = match || null
      }, failure => {
        this.userPoolData = null
      })
    },
    readSubjectRequests () {
      if (this.schoolYearId) {
        this.$store.dispatch('readSubjects', this.schoolYearId)
        this.$store.dispatch('readSubjectRequests', this.schoolYearId)
      }
      this.readUserTeachingTasks()
      this.readUserPoolData()
    }
  },
  watch: {
    showLessonsPerWeek (val) {
      this.$helpers.setLocalStorage('doRequestSubjectsShowLessonsPerWeek', val)
    },
    canShowAssignedSubjects (value) {
      if (value) {
        this.readUserTeachingTasks()
      } else {
        this.userAssignedTeachingTasks = []
        this.userAssignedOtherTasks = []
      }
    },
    requestedSchoolYear (value, oldValue) {
      const nextId = value && value.id ? value.id : null
      const prevId = oldValue && oldValue.id ? oldValue.id : null
      if (nextId !== prevId && this.canShowAssignedSubjects) {
        this.readUserTeachingTasks()
        this.readUserPoolData()
      }
    }
  },
  mounted () {
    const urlParams = new window.URLSearchParams(window.location.search)
    this.schoolYearId = urlParams.get('school_year_id') || 19983
    if (!this.schoolYearId) {
      window.alert('Der mangler et skoleårs ID i URL’en')
    }
    const storedLessons = this.$helpers.getLocalStorage('doRequestSubjectsShowLessonsPerWeek')
    if (storedLessons === 'true') {
      this.showLessonsPerWeek = true
    }
    this.readSubjectRequests()
  },
  beforeDestroy () {
    // Clean up any active timeouts
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.request-subjects {
  padding: 1rem;
}

.request-subjects__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.label-with-toggle {
  display: flex;
  align-items: center;
  padding: 0.5rem;
  border-radius: 4px;
  cursor: pointer;
  transition: 0.15s ease;
  gap: 0.5rem;
}

.label-with-toggle label {
  cursor: pointer;
  white-space: nowrap;
}

.label-with-toggle:hover {
  background: aliceblue;
}

.doTable {
  flex: 1;
  border-radius: 4px;
}

ul.doTable__items {
  margin: 0;
}

.doTable__klass {
  margin: 0;
}

.doTable__klass__header {
  display: flex;
  justify-content: space-between;
  background: #f6f9fc;
  border: 1px solid #e2e8f0;
  text-transform: uppercase;
  padding: 8px;
  font-weight: bold;
}

.doTable__klass__header label {
  color: #c0c0c0;
}

.subjects {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: 10px;
  margin: 0;
  border: 1px solid #e2e8f0;
  border-width: 0 1px 0 1px;
  background-color: #ffffff;
}

.subjects_subject {
  position: relative;
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 4px 6px;
  color: #ffffff !important;
  border-radius: 4px;
  word-break: break-all;
  background: #2c81ba;
  overflow: hidden;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, .3);
  text-align: left;
  min-width: auto;
  font-weight: bold;
  transition: transform 0.25s;
  animation: fadeIn;
  cursor: pointer;
}

.subjects_subject.subject--has-room, .subjects_subject.subject--has-user {
  padding-right: 20px;
}

.subjects_subject.subject--has-room.subject--has-user {
  padding-right: 26px;
}

.subjects_subject.subject--has-room:after {
  content: "\ea38";
  position: absolute;
  top: 9px;
  right: 3px;
  font-family: 'icomoon' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  color: #ffffff;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.subjects_subject.subject--has-user:after {
  content: "\eaf7";
  position: absolute;
  top: 9px;
  right: 3px;
  font-family: 'icomoon' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  color: #ffffff;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.subjects_subject.subject--has-room.subject--has-user:after {
  content: '';
  width: 18px;
  top: 10px;
  height: 18px;
  background-image: url('https://docendo.dk/static/img/app/bulk_create_subjects_userlocation.png');
  background-size: 100%;
  background-repeat: no-repeat;
}

.subject-dist__header {
  margin-bottom: 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.subject-dist__header__left,
.subject-dist__header__right {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.do-bttn.do-bttn--remove {
}

.request-subjects-grid {
  display: flex;
  gap: 1rem;
}

.do-bttn.do-bttn--request-subject {
  padding: 0 6px;
  height: 24px;
}

.do-input {
  background: #fff;
  height: 26px;
  width: 180px;
  border: 1px solid #e4e4e7;
  box-shadow: 0 0 transparent, 0 0 transparent, 0 1px 2px 0 rgba(0, 0, 0, .05);
  transition: width 0.25s, border 0.25s;
}

.do-input:focus {
  border-color: var(--primary);
}

.do-table tbody tr:nth-child(even) {
  background-color: #f9fafb;
}

.do-table__tasks tbody tr td:first-child {
  font-weight: bold;
}

.td-number {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// RequestSubjects.vue?72dfb2e2